import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">当前最受关注的话题标签，点击探索你感兴趣的吃瓜方向</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all border whitespace-nowrap ${
                item.trend === 'hot'
                  ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
                  : item.trend === 'up'
                  ? 'bg-background-50 text-foreground-700 border-background-200 hover:border-primary-200 hover:text-primary-600'
                  : 'bg-background-50 text-foreground-600 border-background-200/60 hover:border-background-300'
              }`}
            >
              <span>{item.name}</span>
              <span className={`text-xs ${item.trend === 'hot' ? 'text-primary-500' : 'text-foreground-400'}`}>
                {item.heat > 50000 ? `${(item.heat / 10000).toFixed(1)}万` : item.heat.toLocaleString()}
              </span>
              {item.trend === 'hot' && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-primary-500"></i>
                </span>
              )}
              {item.trend === 'up' && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-up-line text-xs text-accent-500"></i>
                </span>
              )}
              {item.trend === 'down' && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-down-line text-xs text-foreground-400"></i>
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}